/**
 * Supplies the import wizard's vocabulary to everything below it.
 *
 * Split out from `import-vocabulary.ts` so that module exports no components —
 * mixing the two trips react-refresh/only-export-components, which CI treats as
 * an error (`--max-warnings 0`). See that module for why the vocabulary varies.
 */
import type { ReactNode } from 'react';
import { useMemo } from 'react';

import type { UploadedFileEntry } from '@/lib/csv-import/api';

import {
  ImportVocabularyContext,
  vocabularyForFiles,
} from './import-vocabulary';

export function ImportVocabularyProvider({
  files,
  children,
}: {
  files: UploadedFileEntry[];
  children: ReactNode;
}) {
  const vocabulary = useMemo(() => vocabularyForFiles(files), [files]);
  return (
    <ImportVocabularyContext.Provider value={vocabulary}>
      {children}
    </ImportVocabularyContext.Provider>
  );
}
